__webpack_require__.p = "/tribble/";